import React from "react";
import {
  Building2,
  Zap,
  Activity,
  TrendingUp,
  Thermometer,
  Gauge,
  Lock,
  ArrowRight,
  CheckCircle2,
} from "lucide-react";
import "./AnalyticsMarketing.css";

const BENEFITS = [
  {
    icon: <Activity size={28} />,
    title: "Real-Time Equipment Monitoring",
    description:
      "Live telemetry from your HVAC, chillers, and mechanical systems including supply temps, return temps, amps, and more, all in one view.",
  },
  {
    icon: <Thermometer size={28} />,
    title: "Building Health at a Glance",
    description:
      "Instantly see which buildings and equipment are running efficiently and which need attention, so your team can act before issues escalate.",
  },
  {
    icon: <TrendingUp size={28} />,
    title: "Data-Driven Insights",
    description:
      "DYNAMIQ uses data-driven insights to develop safe, efficient, and sustainable work environments with measurable results that improve your bottom line.",
  },
  {
    icon: <Gauge size={28} />,
    title: "Energy & Performance Optimization",
    description:
      "Optimize energy use and performance across every connected building, minimizing inefficiencies and improving reliability facility-wide.",
  },
];

const OUTCOMES = [
  "Reduce operational risks with continuous monitoring",
  "Strengthen infrastructure through proactive maintenance",
  "Improve employee health and comfort",
  "Adhere to energy and environmental challenges",
  "Increase facility value and image",
  "Drive compliance readiness across your portfolio",
];

const AnalyticsMarketing = () => {
  return (
    <div className="am-wrapper">
      <div className="am-container">

        {/* Hero */}
        <div className="am-hero">
          <div className="am-hero-badge">
            <Lock size={13} />
            Connected Buildings: Not Yet Enabled
          </div>
          <h1 className="am-hero-headline">
            Improving the Building's Impact on the Business.
          </h1>
          <p className="am-hero-sub">
            DYNAMIQ delivers enduring building solutions that improve efficiency,
            strengthen infrastructure, and reduce operational risks. Unlock
            real-time analytics for your facilities with Connected Buildings.
          </p>
          <a
            href="https://www.dynamiq.com/contact"
            className="am-cta-primary"
          >
            Get Your Buildings Connected
            <ArrowRight size={16} />
          </a>
        </div>

        {/* Blurred preview strip */}
        <div className="am-preview-strip">
          <div className="am-preview-label">
            <Lock size={14} />
            Live analytics preview, available with Connected Buildings
          </div>
          <div className="am-preview-grid">
            <div className="am-preview-card am-preview-blur">
              <div className="am-preview-card-header">
                <Building2 size={16} />
                <span>Facilities</span>
              </div>
              <div className="am-preview-stat">4</div>
              <div className="am-preview-stat-label">Enduring building solutions</div>
            </div>
            <div className="am-preview-card am-preview-blur">
              <div className="am-preview-card-header">
                <Zap size={16} />
                <span>Equipment</span>
              </div>
              <div className="am-preview-stat">17</div>
              <div className="am-preview-stat-label">Optimized for performance</div>
            </div>
            <div className="am-preview-card am-preview-blur">
              <div className="am-preview-card-header">
                <Thermometer size={16} />
                <span>Supply Temp</span>
              </div>
              <div className="am-preview-stat">54°F</div>
              <div className="am-preview-stat-label">Live system data</div>
            </div>
            <div className="am-preview-card am-preview-blur">
              <div className="am-preview-card-header">
                <Gauge size={16} />
                <span>Energy Use</span>
              </div>
              <div className="am-preview-stat">18.3A</div>
              <div className="am-preview-stat-label">Measurable results</div>
            </div>
          </div>
          <div className="am-preview-overlay">
            <Lock size={22} />
            <span>Enable Connected Buildings to unlock live data</span>
          </div>
        </div>

        {/* Feature cards */}
        <div className="am-section-label">What you unlock</div>
        <div className="am-features-grid">
          {BENEFITS.map((b, i) => (
            <div className="am-feature-card" key={i}>
              <div className="am-feature-icon">{b.icon}</div>
              <h3 className="am-feature-title">{b.title}</h3>
              <p className="am-feature-desc">{b.description}</p>
            </div>
          ))}
        </div>

        {/* Outcomes + CTA */}
        <div className="am-bottom-row">
          <div className="am-outcomes">
            <div className="am-section-label">With a DYNAMIQ building, you can improve:</div>
            <ul className="am-outcomes-list">
              {OUTCOMES.map((o, i) => (
                <li key={i}>
                  <CheckCircle2 size={16} className="am-check" />
                  {o}
                </li>
              ))}
            </ul>
          </div>

          <div className="am-cta-card">
            <p className="am-cta-question">
              Doesn't your business deserve a DYNAMIQ building?
            </p>
            <p className="am-cta-detail">
              Our process is intelligent and strategic in order to achieve the
              greatest results. Contact us to connect your facilities and unlock
              the full Analytics experience.
            </p>
            <a
              href="https://www.dynamiq.com/contact"
              className="am-cta-primary"
            >
              Contact DYNAMIQ
              <ArrowRight size={16} />
            </a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AnalyticsMarketing;
